import { AIVOICE_TONE, AIVOICE_VIBE } from '@/constants/aivoiceConstants';
import { downloadTTSFileApi, getVoiceOptionListApi, getVoiceTemplateListApi, listenTextPreviouslyApi } from './api/brandApi';
import { findKeyByValue } from '@/utils/mapper';
const aiVoiceService = {
  /**
   * @param {Object} param
   * @param {string} param.corpId
   * @param {string} param.brandId
   */
  async getVoiceTemplate(param) {
    try {
      const { data } = await getVoiceTemplateListApi(param);
      if (data.resultCd === '0000') {
        return {
          success: true,
          voiceTemplateList: data.result,
        };
      }
      throw Error('getVoiceTemplateListApi Error : ' + data.resultCd);
    } catch (error) {
      return {
        success: false,
        error,
      };
    }
  },
  /**
   * @param {Object} param
   * @param {string} param.corpId
   * @param {string} param.brandId
   */
  async getVoiceOption(param) {
    try {
      const { data } = await getVoiceOptionListApi(param);
      if (data.resultCd === '0000') {
        return {
          success: true,
          voiceOptionList: data.result.map(item => ({
            ...item,
            vibeKey: findKeyByValue(AIVOICE_VIBE, item.vibe),
            toneKey: findKeyByValue(AIVOICE_TONE, item.tone),
            isActive: false,
          })),
        };
      }
      throw Error('getVoiceOptionListApi Error : ' + data.resultCd);
    } catch (error) {
      return {
        success: false,
        error,
      };
    }
  },
  /**
   * createTtsV2 호출 후 fileTempNo(tempNo)를 받아 downloadTTSFile까지 이어서 실행
   *
   * @param {Object} param
   * @param {string} param.corpId
   * @param {string} param.brandId
   * @param {string} param.textOfMessage
   * @param {number} param.optionNo
   * @returns {Promise<
   *  | { success: true, fileTempNo: number|string, headers: Object, body: string, statusCode: string, statusCodeValue: number }
   *  | { success: false, error: any, step?: 'create' | 'download' }
   * >}
   */
  async generateTts(param) {
    try {
      // 1) 생성
      const created = await this.createTtsV2({
        corpId: param.corpId,
        brandId: param.brandId,
        textOfMessage: param.textOfMessage,
        optionNo: param.optionNo,
      });

      if (!created.success) {
        return { success: false, step: 'create', error: created.error };
      }

      const fileTempNo = created.fileTempNo;

      // 2) 다운로드
      const downloaded = await this.downloadTTSFile({
        corpId: param.corpId,
        brandId: param.brandId,
        tempNo: fileTempNo, // download는 tempNo를 받는다고 하셨죠
      });
      if (!downloaded.success) {
        return { success: false, step: 'download', error: downloaded.error };
      }

      return {
        success: true,
        fileTempNo,
        headers: downloaded.headers,
        body: downloaded.body,
        statusCode: downloaded.statusCode,
        statusCodeValue: downloaded.statusCodeValue,
      };
    } catch (error) {
      return {
        success: false,
        error,
      };
    }
  },
  /**
   *
   * @param {Object} param
   * @param {string} param.corpId
   * @param {string} param.brandId
   * @param {string} param.textOfMessage
   * @param {number} param.optionNo
   */
  async createTtsV2(param) {
    try {
      const { data } = await listenTextPreviouslyApi(param);
      if (data.resultCd === '0000') {
        return {
          success: true,
          fileTempNo: data.result,
        };
      }
      throw Error('listenTextPreviouslyApi resultCd : ' + data.resultCd);
    } catch (error) {
      return {
        success: false,
        error,
      };
    }
  },
  /**
   *
   * @param {Object} param
   * @param {string} param.corpId
   * @param {string} param.brandId
   * @param {number} param.tempNo
   */
  async downloadTTSFile(param) {
    try {
      const { data } = await downloadTTSFileApi(param);
      if (data.resultCd === '0000') {
        return {
          success: true,
          headers: data.result.headers,
          body: data.result.body,
          statusCode: data.result.statusCode,
          statusCodeValue: data.result.statusCodeValue,
        };
      }
      throw Error('downloadTTSFileApi Error : ' + data.resultCd);
    } catch (error) {
      return {
        success: false,
        error,
      };
    }
  },
};
export default aiVoiceService;
